import { useParams } from "react-router-dom";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import Dashboard from "../../common/components/layout/Dashboard";
import { NegativationDashboard } from "./components/negativation-dashboard";
import { NegativationDashboardProvider } from "./components/negativation-dashboard/NegativationDashboard.provider";

function NegativationDetailsPage() {
  const { negativationId } = useParams()

  return (
    <ToastProvider>
      <Dashboard>
        <NegativationDashboardProvider negativationId={negativationId || ''}>
          <NegativationDashboard />
        </NegativationDashboardProvider>
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default NegativationDetailsPage